import $ from 'jquery';

import './_opentherm-dialog.sass';

import Class from '../legacy-class';

import '../../../../mui/dialog';
import {pad0, prettyFloat} from '../../../../utils/number';

const OpenThermDialog = Class({
    init(ui, device) {
        this._ui = ui;
        this._device = device;

        this._empty = true;

        // noinspection CheckTagEmptyBody
        this._element = $(`
            <div class="ui-opentherm-dialog" style="display: none">
                <h1 class="mui_dialog_title">Диагностика цифровой шины</h1>
               
                <div class="ui-opentherm-dialog-toolbar clearfix">
                    <div class="ui-opentherm-dialog-loading" style="float: right">
                        Запрос данных<span class="dot dot-1">.</span><span class="dot dot-2">.</span><span class="dot dot-3">.</span>
                    </div>
                   
                    <select class="ui-opentherm-dialog-selector"></select>
                    <button class="ui-opentherm-dialog-refresh">обновить</button>
                </div>
               
                <div class="ui-opentherm-dialog-content">
                    <div class="ui-opentherm-dialog-scroller">
                   
                        <div class="ui-opentherm-dialog-section">
                            <h1>Параметры</h1>
                           
                            <table opentherm="s">
                                <caption>Статус</caption>
                               
                                <tr flag="f">
                                    <th></th>
                                    <td class="fault"><span></span></td>
                                </tr>
                                <tr flag="ch">
                                    <th>Отопление</th>
                                    <td></td>
                                </tr>
                                <!--
                                <tr flag="ch2">
                                    <th>2 контур отопления</th>
                                    <td></td>
                                </tr>
                                -->
                                <tr flag="dhw">
                                    <th>ГВС</th>
                                    <td></td>
                                </tr>
                                <tr flag="fl">
                                    <th>Горелка</th>
                                    <td></td>
                                </tr>
                                <tr flag="cl">
                                    <th>Охлаждение</th>
                                    <td></td>
                                </tr>
                                <tr flag="di">
                                    <th>Диагностическое сообщение</th>
                                    <td></td>
                                </tr>
                            </table>
                               
                            <table opentherm="sc">
                                <caption>Конфигурация котла</caption>
                               
                                <tr flag="ct">
                                    <th>Тип управления</th>
                                    <td></td>
                                </tr>
                                <!--
                                <tr flag="ch2">
                                    <th>2 контур отопления</th>
                                    <td></td>
                                </tr>
                                -->
                                <tr flag="mpf">
                                    <th>Управление насосом</th>
                                    <td></td>
                                </tr>
                                <tr flag="dhw">
                                    <th>ГВС</th>
                                    <td></td>
                                </tr>
                                <tr flag="dhwc">
                                    <th>Тип ГВС</th>
                                    <td></td>
                                </tr>
                                <tr flag="cc">
                                    <th>Управление охлаждением</th>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                               
                        <div class="ui-opentherm-dialog-section">
                            <h1>Отопление</h1>
                               
                            <table>
                                <tr opentherm="cs">
                                    <th>Заданная t° теплоносителя</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                <tr opentherm="bt">
                                    <th>Фактическая t° теплоносителя</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                <tr opentherm="rwt">
                                    <th>t° обратного потока</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                <tr opentherm="rp">
                                    <th>Целевая t° помещения</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                <!--
                                <tr opentherm="rt">
                                    <th>Фактическая t° помещения</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                -->
                                <tr opentherm="ot">
                                    <th>Температура вне дома</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                            <!--
                            </table>
               
                        </div>
               
                        <div class="ui-opentherm-dialog-section">
               
                            <h1>???</h1>
               
                            <table>
                                -->
                                <tr opentherm="rml">
                                    <th>Уровень модуляции</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">%</td>
                                </tr>
                                <tr opentherm="wp">
                                    <th>Давление в системе отопления</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">бар</td>
                                </tr>
                            </table>
                        </div>
                               
                        <div class="ui-opentherm-dialog-section">
                            <h1>Горячее водоснабжение</h1>
                               
                            <table>
                                <tr opentherm="ds">
                                    <th>Заданная температура ГВС</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                <tr opentherm="dt">
                                    <th>Фактическая температура ГВС</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                <tr opentherm="fr">
                                    <th>Скорость потока ГВС</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">л/мин</td>
                                </tr>
                                <tr opentherm="db">
                                    <th>Границы температуры ГВС</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                            </table>
                        </div>
                               
                        <div class="ui-opentherm-dialog-section">
                            <h1>Прочее</h1>
                               
                            <table>
                                <tr opentherm="b">
                                    <th>Границы t° теплоносителя</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">°C</td>
                                </tr>
                                <tr opentherm="mrml">
                                    <th>Максимальный уровень модуляции</th>
                                    <td class="int"></td>
                                    <td class="frac"></td>
                                    <td class="unit">%</td>
                                </tr>
                                <!--
                                <tr opentherm="rors">
                                    <th></th>
                                    <td></td>
                                </tr>
                                <tr opentherm="rof">
                                    <th></th>
                                    <td></td>
                                </tr>
                                -->
                                <tr opentherm="sv">
                                    <th>Версия котла</th>
                                    <td colspan="3"></td>
                                </tr>
                                <tr opentherm="mv">
                                    <th>Версия термостата</th>
                                    <td colspan="3"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `);

        this._adapter_no = 0;

        this._buttons = this._element.find('button');

        this._buttons.click(() => {
            if (!this._device.online()) {
                $.mui.mui_dialog.errorbox({
                    title: 'Термостат не на связи',
                    message:
                        'Запросить параметры котла можно<br/>только когда термостат на связи',
                });
                return;
            }

            this._device.request_opentherm_count();
            this._device.request_opentherm_diag(this._adapter_no);
            this._element.find('.ui-opentherm-dialog-loading').addClass('visible');

            const blocker = this._element.find('.ui-opentherm-dialog-blocker');
            blocker.addClass('visible');
            this._buttons.prop('disabled', true);
        });

        this._selector = this._element.find('.ui-opentherm-dialog-selector');
        this._selector.change(() => {
            console.log('selector changed', this._selector.val());
            this._adapter_no = parseInt(this._selector.val());
            this._clear();
            this._buttons.trigger('click');
        });

        this._device.bind({
            request_opentherm_count_response: ({ok, ids}) => {
                const old_val = this._selector.val() ?? this._adapter_no;
                this._selector
                    .html(
                        ids
                            .map(
                                (id, i) =>
                                    `<option value='${i}'>Цифровая шина №${
                                        i + 1
                                    } (${id})</option>`
                            )
                            .join('')
                    )
                    .toggleClass('visible', ids.length > 1)
                    .val(old_val);
            },

            request_opentherm_diag_response: () => {
                this._element
                    .find('.ui-opentherm-dialog-blocker')
                    .removeClass('visible');
                // @_element.find('.ui-opentherm-dialog-refresh').removeClass 'hidden'
                this._element
                    .find('.ui-opentherm-dialog-loading')
                    .removeClass('visible');
                this._buttons.prop('disabled', false);
            },

            opentherm_diag_value: ({param_no, adapter_no, name, value}) => {
                if (
                    value != null &&
                    (adapter_no == null || adapter_no === this._adapter_no)
                ) {
                    this._empty = false;
                    this._fillParam(name, value);
                }
            },
        });
    },

    _clear() {
        // @_element.find('.ui-opentherm-dialog-refresh').addClass 'hidden'
        this._element.find('.ui-opentherm-dialog-blocker').removeClass('visible');
        this._element
            .find('.ui-opentherm-dialog-section, [opentherm]')
            .removeClass('visible');
    },

    _fillParam(name, value) {
        console.log('_fillParam', name, value);
        const div = this._element.find(`[opentherm~=\"${name}\"]`);
        div.addClass('visible');
        div.closest('.ui-opentherm-dialog-section').addClass('visible');

        switch (name) {
            case 'cs':
            case 'bt':
            case 'rwt':
            case 'rp':
            case 'rt':
            case 'ot':
            case 'ds':
            case 'dt':
            case 'wp':
            case 'fr': {
                const parts = value.toFixed(1).split('.');
                div.find('.int').text(parts[0]);
                div.find('.frac').text(parts[1] !== '0' ? '.' + parts[1] : '');
                if (name !== 'fr') div.toggleClass('off', value === 0);
                break;
            }
            case 'rml':
            case 'mrml':
                div.find('.int').text(parseInt(value, 10));
                break;
            case 'b':
            case 'db':
                div.toggleClass('off', value[0] === value[1] && value[1] === 0)
                    .find('.int')
                    .text(
                        `${prettyFloat(value[0], 1)} ... ${prettyFloat(value[1], 1)}`
                    );
                break;

            case 'mv':
            case 'sv':
                div.toggleClass('off', value[0] === value[1] && value[1] === 0)
                    .find('td')
                    .text(`тип ${value[0]}, версия ${value[1]}`);
                break;

            case 's':
                div.find('[flag="f"] th')
                    .text(value.includes('f') ? 'АВАРИЯ' : 'Аварии нет')
                    .toggleClass('fault', value.includes('f'))
                    .toggleClass('good', !value.includes('f'));

                div.find('[flag="f"] td span').toggleClass(
                    'hidden',
                    !value.includes('f')
                );

                div.find('[flag="ch"] ')
                    .toggleClass('off', !value.includes('ch'))
                    .find('td')
                    .text(value.includes('ch') ? 'активно' : 'неактивно');
                div.find('[flag="ch2"]')
                    .toggleClass('off', !value.includes('ch2'))
                    .find('td')
                    .text(value.includes('ch2') ? 'активно' : 'неактивно');
                div.find('[flag="dhw"]')
                    .toggleClass('off', !value.includes('dhw'))
                    .find('td')
                    .text(value.includes('dhw') ? 'активно' : 'неактивно');
                div.find('[flag="fl"] ')
                    .toggleClass('off', !value.includes('fl'))
                    .find('td')
                    .text(value.includes('fl') ? 'активна' : 'неактивна');
                div.find('[flag="cl"] ')
                    .toggleClass('off', !value.includes('cl'))
                    .find('td')
                    .text(value.includes('cl') ? 'активно' : 'неактивно');
                return div
                    .find('[flag="di"] ')
                    .toggleClass('off', !value.includes('di'))
                    .find('td')
                    .text(value.includes('di') ? 'есть' : 'нет');

            case 'ff': {
                const fv = this._element.find('[opentherm~="s"] [flag="f"] td span');
                fv.empty();

                if (value.c != null)
                    fv.append(`<div>Код ошибки OEM: E${pad0(value.c, 2)}</div>`);
                if (value.f.includes('sr'))
                    fv.append(
                        '<div title="Service request">Необходимо обслуживание</div>'
                    );
                if (value.f.includes('lr'))
                    fv.append(
                        '<div title="Lockout-reset">Требуется ручной сброс</div>'
                    );
                if (value.f.includes('wp'))
                    fv.append(
                        '<div title="Low water pressure">Низкое давление теплоносителя</div>'
                    );
                if (value.f.includes('gf'))
                    fv.append('<div title="Gas/flame fault">Сбой газа/горелки</div>');
                if (value.f.includes('ap'))
                    fv.append(
                        '<div title="Air pressure fault">Сбой давления воздуха</div>'
                    );
                if (value.f.includes('wot'))
                    fv.append(
                        '<div title="Water over-temperature">Превышение температуры</div>'
                    );
                break;
            }

            case 'sc': {
                div.find('[flag="ct"] td').text(
                    value.f.includes('ct') ? 'вкл/выкл' : 'модуляция'
                );
                div.find('[flag="ch2"] ')
                    .toggleClass('off', !value.f.includes('ch2'))
                    .find('td')
                    .text(value.f.includes('ch2') ? 'включено' : 'выключено');
                div.find('[flag="mpf"] ')
                    .toggleClass('off', !value.f.includes('mpf'))
                    .find('td')
                    .text(
                        value.f.includes('mpf') ? 'поддерживается' : 'не поддерживается'
                    );
                div.find('[flag="dhw"] ')
                    .toggleClass('off', !value.f.includes('dhw'))
                    .find('td')
                    .text(value.f.includes('dhw') ? 'включено' : 'выключено');
                div.find('[flag="dhwc"]')
                    .toggleClass('off', !value.f.includes('dhwc'))
                    .find('td')
                    .text(value.f.includes('dhwc') ? 'с накопителем' : 'проточное');
                div.find('[flag="cc"]  ')
                    .toggleClass('off', !value.f.includes('cc'))
                    .find('td')
                    .text(value.f.includes('cc') ? 'включено' : 'выключено');
                break;
            }
        }
    },

    open() {
        if (!this._device.online()) {
            $.mui.mui_dialog.errorbox({
                title: 'Термостат не на связи',
                message:
                    'Запросить параметры котла можно<br/>только когда термостат на связи',
            });
            return;
        }

        if (this._empty) this._buttons.trigger('click');

        this._element.mui_dialog({
            buttons: [
                {
                    text: 'закрыть',
                    click: () => this._element.mui_dialog('close'),
                },
            ],
        });
    },
});

OpenThermDialog._instances = {};
OpenThermDialog.for_device = (ui, device) => {
    if (OpenThermDialog._instances[device.id()] == null) {
        OpenThermDialog._instances[device.id()] = new OpenThermDialog(ui, device);
    }
    return OpenThermDialog._instances[device.id()];
};

export default OpenThermDialog;
